<template>
  <div class="h-full flex justify-center bg-black px-2 sm:px-6 overflow-hidden">
    <div class="max-w-5xl w-full py-0 sm:py-4 md:py-10 xl:py-14 overflow-hidden">
      <div class="items-center overflow-hidden">
        <div v-if="remeShow" id="lds-roller" class="lds-roller mx-auto min-w-full w-auto">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div id="playImage" v-show="playImage" class="mx-auto min-w-full w-auto">
          <img id="imageWrap" :key="imageURL" :src="imageURL" class="mx-auto min-w-full rounded" />
        </div>

        <div id="playVideo" v-show="playVideo" class="mx-auto min-w-full w-auto">
          <video
            id="videoID"
            autoplay
            muted
            playsinline
            class="mx-auto min-w-full w-auto rounded"
            :key="videoURL"
          >
            <source :src="videoURL" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <div>
      <img v-show="showthis" :src="preloadImage" width="0px" height="0px" />
      <video v-show="showthis" :src="preloadVideo" width="0px" height="0px" preload></video>
    </div>
  </div>
</template>

<script>
export default {
  name: "Player",
  components: {},
  data() {
    return {
      tempList: [],
      localPlaylist: [],
      newsContainer: [],
      adsContainer: [],
      currentItem: 0,
      playImage: false,
      playVideo: false,
      imageURL: "",
      videoURL: "",
      preloadImage: "",
      preloadVideo: "",
      showthis: false,
      remeShow: true,
      adsPath: "https://fra1.digitaloceanspaces.com/fahrgastfernsehen/ads/",
      newsPath: "https://fra1.digitaloceanspaces.com/fahrgastfernsehen/news/"
    };
  },
  created() {
    // this.GET_PLAYLIST_NEWS();
    // this.GET_PLAYLIST_ADS();
    // this.MAKE_LOCAL_PLAYLIST();
    setTimeout(this.GET_PLAYLIST_NEWS, 1000);
    setTimeout(this.GET_PLAYLIST_ADS, 2000);
    setTimeout(this.MAKE_LOCAL_PLAYLIST, 3000);
    setTimeout(this.PLAY_LOOP, 4000);
  },
  methods: {
    MAKE_LOCAL_PLAYLIST: function() {
      document.title = "creating playlist";
      // let localtempList = [];
      // let localtempPlaylist = [];
      this.tempList.length = 0;
      this.localPlaylist.length = 0;
      let { newsContainer, adsContainer } = this;
      // console.log("NEWS: " + newsContainer.length + " items");
      // console.log("ADS: " + adsContainer.length + " items");
      this.tempList.push(newsContainer[7]); // set container 8 first
      let bigger,
        smaller,
        pmodulo,
        pcounter = 0;
      if (newsContainer.length > adsContainer.length) {
        bigger = newsContainer;
        smaller = adsContainer;
        // console.log("NEWS gt ADS");
      } else {
        smaller = newsContainer;
        bigger = adsContainer;
        // console.log("ADS gt NEWS");
      }
      pmodulo = parseInt(bigger.length / smaller.length);
      // console.log("MODULO: " + pmodulo);

      if (pmodulo < 2) {
        bigger.forEach(container => {
          if (smaller[pcounter] === undefined) {
            pcounter = 0;
          } else {
            this.tempList.push(container);
          }
          this.tempList.push(smaller[pcounter]);
          pcounter++;
        });
      } else {
        bigger.forEach((container, idx) => {
          if (idx % pmodulo === 0) {
            if (smaller[pcounter] === undefined) {
              pcounter = 0;
            }
            this.tempList.push(smaller[pcounter]);
            pcounter++;
          } else {
            this.tempList.push(container);
          }
        });
      }

      this.tempList.map(container => {
        container.contents.map(content => {
          this.localPlaylist.push(content);
        });
      });
      // this.localPlaylist = localtempPlaylist;
    },
    GET_PLAYLIST_NEWS: function() {
      document.title = "loading news-table";
      let that = this;
      var ts = Math.round(new Date().getTime() / 1000);
      // console.log("### GETTING NEWS PLAYLIST ###");
      let xhr = new XMLHttpRequest();
      xhr.open("GET", this.newsPath + "nachrichten.json?ts=" + ts, true);
      // If specified, responseType must be empty string or "text"
      xhr.responseType = "";
      xhr.onload = function() {
        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            let response = JSON.parse(xhr.responseText);
            that.newsContainer.length = 0;
            response.channels[0].containers.map(container => {
              if (container.start < ts && container.end > ts) {
                // console.log(
                //   "ContainerTimeOK: NumElements: " + container.contents.length
                // );
                that.newsContainer.push(container);
              }
            });
          }
        }
      };
      xhr.send(null);
    },
    GET_PLAYLIST_ADS: function() {
      document.title = "loading ads-table";
      let that = this;
      var ts = Math.round(new Date().getTime() / 1000);
      // console.log("### GETTING ADS PLAYLIST ###");

      let xhr = new XMLHttpRequest();
      xhr.open("GET", this.adsPath + "werbung.json?ts=" + ts, true);

      // If specified, responseType must be empty string or "text"
      xhr.responseType = "";

      xhr.onload = function() {
        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            let response = JSON.parse(xhr.responseText);
            that.adsContainer.length = 0;
            response.channels[0].containers.map(container => {
              if (
                container.player_ids[0] === "onlinecontent-001" &&
                container.start < ts &&
                container.end > ts
              ) {
                // console.log(
                //   "ContainerTimeOK: NumElements: " + container.contents.length
                // );
                that.adsContainer.push(container);
              }
            });
          }
        }
      };

      xhr.send(null);
    },
    PLAY_LOOP: function() {
      if (this.remeShow) {
        this.remeShow = false;
      }
      document.title = "Das Fahrgastfernsehen";
      let idx = this.currentItem;

      // console.log(idx);

      let item = this.localPlaylist[idx];
      let vid = document.getElementById("videoID");
      if (item.type === "video") {
        // vid.pause();
        vid.width = "100%";
        this.playImage = false;
        this.playVideo = true;
        if (item.filename.match(/^spotid_.*/i)) {
          this.videoURL = this.adsPath + item.filename;
        } else {
          this.videoURL = this.newsPath + item.filename;
        }
        // vid.load();
        // vid.play();
        // console.log("#####################################################");
        // console.log("VIDEO: " + item.filename);
        // console.log("DURATION: " + item.duration + " s");
        // console.log("#####################################################");
        this.currentItem++;
        setTimeout(this.PLAY_LOOP, 1000 * item.duration);

        // setTimeout(this.PLAY_LOOP, 2000);
      }
      if (item.type === "image") {
        // vid.pause();
        this.playVideo = false;
        this.playImage = true;
        if (item.filename.match(/^spotid_.*/i)) {
          this.imageURL = this.adsPath + item.filename;
        } else {
          this.imageURL = this.newsPath + item.filename;
        }
        // console.log("#####################################################");
        // console.log("IMAGE: " + item.filename);
        // console.log("DURATION: " + item.duration + " s");
        // console.log("#####################################################");
        this.currentItem++;
        setTimeout(this.PLAY_LOOP, 1000 * item.duration);
        // setTimeout(this.PLAY_LOOP, 2000);
      }

      if (this.currentItem > this.localPlaylist.length - 1) {
        this.GET_PLAYLIST_NEWS();
        this.GET_PLAYLIST_ADS();
        this.MAKE_LOCAL_PLAYLIST();
        this.currentItem = 0;
        // setTimeout(this.PLAY_LOOP, 1000 * item.duration);
      }

      let next_idx = this.currentItem;

      for (next_idx; next_idx < this.localPlaylist.length - 1; next_idx++) {
        let next_item = this.localPlaylist[next_idx];
        this.currentItem = next_idx;
        if (this.PRELOAD_CHECK(next_idx)) {
          if (next_item.type === "video") {
            if (next_item.filename.match(/^spotid_.*/i)) {
              this.preloadVideo = this.adsPath + next_item.filename;
            } else {
              this.preloadVideo = this.newsPath + next_item.filename;
            }
          }
          if (next_item.type === "image") {
            if (next_item.filename.match(/^spotid_.*/i)) {
              this.preloadImage = this.adsPath + next_item.filename;
            } else {
              this.preloadImage = this.newsPath + next_item.filename;
            }
          }
          break;
        }
      }
    },
    PRELOAD_CHECK: function(next_idx) {
      let checkPassed = false;
      let next_item = this.localPlaylist[next_idx];
      let checkPath = "";
      if (next_item.filename.match(/^spotid_.*/i)) {
        checkPath = this.adsPath;
      } else {
        checkPath = this.newsPath;
      }

      var xhr = new XMLHttpRequest();
      xhr.open("HEAD", checkPath + next_item.filename, false);
      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            checkPassed = true;
          }
        }
      };
      xhr.send(null);

      return checkPassed;
    }
  }
};
</script>
<style>
video {
  /* override other styles to make responsive */
  width: 100% !important;
  height: auto !important;
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  margin: 90px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>